import React from 'react';
import SubmissionDetails from '../../../SubmissionDetails';
import s from './Poll.scss';
export var PollDetails = function (_a) {
    var poll = _a.deviation.poll, deviation = _a.deviation;
    if (!poll) {
        return null;
    }
    return (React.createElement("div", { className: s['root'] },
        React.createElement(SubmissionDetails, { deviation: deviation, className: s['details'] })));
};
PollDetails.displayName = 'PollDetails';
export default PollDetails;
//# sourceMappingURL=Poll.js.map